import { render } from "./LoadFile.vue?vue&type=template&id=37de037e"
import script from "./LoadFile.vue?vue&type=script&lang=js"
export * from "./LoadFile.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\WS-CI002090\\workspace\\informativo\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__